import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export interface KpiData {
  newOutlets: number;
  totalRevenue: number;
  totalVolume: number;
  wod: number;
  activeAccounts?: number;
  lapsedAccounts?: number;
  inactiveAccounts?: number;
}

export interface KpiFilters {
  startDate?: string;
  endDate?: string;
  licenseType?: string;
  pinCode?: string;
  salesRep?: string;
}

export interface ComparisonFilterParams {
  period_one: {
    startDate: string;
    endDate: string;
  };
  period_two: {
    startDate: string;
    endDate: string;
  };
  card_type: string[];
}

export interface KpiCardData {
  key: string;
  name: string;
  unit: string;
  details: any;
  isPeriodOneDataExists?: boolean;
  isPeriodTwoDataExists?: boolean;
}

export type OutstandingAgeingReportRow = {
  serial_id: number;
  outlet_name: string;
  order_id: string;
  invoice_number: string;
  total_bill_amount: number;
  amount_paid: number;
  outstanding_amount: number;
  ageing_days: number;
};

export type OutstandingAgeingReportResponse = {
  message: string;
  data: OutstandingAgeingReportRow[];
};

export const dashboardAPI = {
  getKPIDetails: async (
    filters?: KpiFilters,
    sellerEmail?: string,
    dashboardType?: string,
    customerEmail?: string
  ) => {
    try {
      const params: any = {};
      if (filters) params.filters = JSON.stringify(filters);
      if (sellerEmail) params.sellerEmail = sellerEmail;
      if (dashboardType) params.dashboardType = dashboardType;
      if (customerEmail) params.customerEmail = customerEmail;

      const response = await api.get(`/get-kpi-details`, {
        params,
        headers: {
          orgId: getApiOrganizationId(),
        },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error fetching KPI details:", error);
      throw error;
    }
  },

  getKPICardsWithComparison: async (
    filters?: KpiFilters,
    sellerEmail?: string,
    dashboardType?: string,
    compFilter?: ComparisonFilterParams,
    customerEmail?: string
  ): Promise<KpiCardData[]> => {
    try {
      const params: any = {};

      if (filters) params.filters = JSON.stringify(filters);
      if (sellerEmail) params.sellerEmail = sellerEmail;
      if (dashboardType) params.dashboardType = dashboardType;
      if (customerEmail) params.customerEmail = customerEmail;
      if (compFilter) params.comparison_filter = JSON.stringify(compFilter);

      const response = await api.get(`/get-kpi-cards`, {
        params,
        headers: {
          orgId: getApiOrganizationId(),
        },
      });
      return response.data.data;
    } catch (error) {
      console.error("Error fetching KPI cards with comparison:", error);
      throw error;
    }
  },
  getOutstandingAgeingReport: async (
    filters: any | undefined,
    dashboardType: string | undefined,
    dateValue: string,
    bucketValue: string,
    sellerEmail?: string,
    customerEmail?: string
  ): Promise<OutstandingAgeingReportResponse> => {
    const params: any = {};

    if (filters) params.filters = JSON.stringify(filters);
    if (dashboardType) params.dashboardType = dashboardType;

    params.dateValue = dateValue;
    params.bucketValue = bucketValue;

    if (dashboardType === "finance-analytics") {
      if (customerEmail) params.customerEmail = customerEmail;
      if (sellerEmail) params.sellerEmail = sellerEmail;
    } else {
      if (sellerEmail) params.sellerEmail = sellerEmail;
      if (customerEmail) params.customerEmail = customerEmail;
    }

    const res = await api.get(`/osa_report`, {
      params,
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return res.data;
  },
};
